import * as types from "../actions/ActionTypes";
import { objectInitial } from "../store/InitialStore";

export default function ChoosePlanReducer(state = objectInitial, action) {
  const { type, payload } = action;

  switch (type) {
    case types.CHOOSE_PLAN_LOADING:
      return {
        ...state,
        choosePlan: [],
        loading: true,
        error: false,
      };

    case types.CHOOSE_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        choosePlan: payload,
        error: false,
      };
    case types.CHOOSE_PLAN_ERROR:
      return {
        ...state,
        choosePlan: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
